export const filterString = (stringValue, filterCallback) => [...stringValue].filter(filterCallback).join('');
